import { useState } from "react";
import { toast } from "sonner";
import { Bot, Loader2, Send } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const IDEAS = ["ai.idea1", "ai.idea2", "ai.idea3"];

export const AiEditBox = ({ video, cfg, setCfg, range, setRange, active }) => {
  const { t, lang } = useI18n();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const run = async (instruction) => {
    if (!instruction.trim()) return;
    setBusy(true);
    try {
      const { effects, stickers, sfx, hook, title, hashtags, aspect, fit, impact } = cfg;
      const { data } = await api.post("/ai/edit", {
        video_id: video.id, instruction, lang,
        cfg: { effects, stickers, sfx, hook, title, hashtags, aspect, fit, impact, length: +(range.end - range.start).toFixed(2) },
        context: { game: video.game, label: active?.label, reason: active?.reason, category: active?.category },
      });
      const { start_delta = 0, end_delta = 0, message, ...rest } = data;
      setCfg((c) => ({ ...c, ...rest }));
      if (start_delta || end_delta) {
        setRange((r) => {
          const start = Math.max(0, r.start + start_delta);
          return { start, end: Math.max(start + 0.5, Math.min(video.duration || r.end + end_delta, r.end + end_delta)) };
        });
      }
      setMsg(message);
      setText("");
      toast.success(t("ai.applied"));
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="rounded-xl border border-[#a746ff]/35 bg-gradient-to-br from-[#2f7bff]/10 to-[#a746ff]/10 p-4" data-testid="ai-edit-box">
      <div className="flex items-center gap-2 text-sm font-display font-semibold text-white"><Bot className="w-4 h-4 text-[#c79bff]" /> {t("ai.title")}</div>
      <p className="text-[11px] text-slate-400 mt-1">{t("ai.sub")}</p>
      <form onSubmit={(e) => { e.preventDefault(); run(text); }} className="flex gap-2 mt-3">
        <input data-testid="ai-edit-input" value={text} onChange={(e) => setText(e.target.value)} placeholder={t("ai.ph")} className="flex-1 min-w-0 rounded-lg bg-[#070912] border border-white/10 px-3 py-2.5 text-sm outline-none focus:border-[#a746ff]" />
        <button data-testid="ai-edit-submit" disabled={busy} className="cx-btn rounded-lg px-3">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}</button>
      </form>
      <div className="flex flex-wrap gap-1.5 mt-2">
        {IDEAS.map((k) => <button key={k} data-testid={`ai-idea-${k.slice(-1)}`} onClick={() => run(t(k))} disabled={busy} className="text-[10px] px-2 py-1 rounded-full border border-white/10 text-slate-400 hover:text-white hover:border-[#a746ff]/50 transition-colors">{t(k)}</button>)}
      </div>
      {msg && <p className="text-xs text-[#c79bff] mt-3" data-testid="ai-edit-message">{msg}</p>}
    </div>
  );
};
